import styled from 'styled-components/macro';

export const Image = styled.img`
  height: 100%;
  width: 100%;
  border-radius: 6px;
  object-fit: contain;
`;

export const ImageContainer = styled.div<{ disabled?: boolean }>`
  position: relative;
  width: 100%;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.theme.colors.neutral[10]};
  cursor: pointer;
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;

export const PlaceholderBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 6px;
  border: 1px dashed ${props => props.theme.colors.neutral[40]};
  background-color: transparent;
  color: ${props => props.theme.colors.neutral[60]};
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition:
    border-color 0.2s ease-in-out,
    color 0.2s ease-in-out;

  &:hover {
    border-color: ${props => props.theme.colors.primary[60]};
    color: ${props => props.theme.colors.primary[80]};
  }
`;

export const ProgressBar = styled.div<{ progress: number }>`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: ${({ progress }) => progress}%;
  background-color: ${props => props.theme.colors.secondary[100]};
  opacity: 0.2;
  transition: width 0.2s ease-in-out;
  border-radius: 6px;
`;

export const ProgressContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 145px;
  border-radius: 6px;
  border: 1px dashed ${props => props.theme.colors.neutral[40]};
  background-color: ${props => props.theme.colors.neutral[10]};
  color: ${props => props.theme.colors.neutral[80]};
  font-weight: 600;
  font-size: 15px;
  overflow: hidden; // Important for the progress bar's border-radius
`;
